import React from 'react';
import reqwest from 'reqwest';
import ReactTable from 'react-table';

import settings from '../../../../../settings';

import Loader from '../../../../components/Loader';
import Button from '../../../../components/Button';
import RightSide from '../../../../components/FormArea/RightSide';
import ContentBox from '../../../../components/FormArea/ContentBox';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

class EMailTemplateOverview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      eMailTemplateList: [],
      loading: true,
    };

    reqwest({
      method: 'get',
      url: settings.systemmanagement.emailtemplate.getList,
      contentType: 'json',
      data: {
        Token: localStorage.getItem('token'),
      },
    }).then(emailtemplateListResponse => {
      const eMailTemplateList = JSON.parse(emailtemplateListResponse).filter(emailclient => {
        return emailclient?.Params?.Guid !== '';
      });

      this.setState({
        eMailTemplateList,
        loading: false,
      });
    });
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className='FormArea-Form-Left'>
          <ContentBox title='E-Mail Templates'>
            <ReactTable
              getTrProps={(_, { original }) => ({
                onClick: () => this.props.history.replace(`${this.props.match.url}/${original.Params.Guid}`),
              })}
              data={this.state.eMailTemplateList}
              pageSize={this.state.eMailTemplateList.length}
              noDataText='Es liegen keine Templates vor.'
              columns={[
                {
                  Header: 'Template',
                  accessor: 'Params.Title',
                },
              ]}
            />
          </ContentBox>
        </div>
        <RightSide>
          <Button big icon={faPlus} to={`${this.props.match.url}/new`} replace>
            Neues EMail Template
          </Button>
        </RightSide>
      </>
    );
  }
}

export default EMailTemplateOverview;
